export default {
  alerts: []
}
